import { FC, useCallback, useEffect, useState } from 'react';
import { Box, useTheme } from '@mui/material';
import { StorefrontBanner } from '../../ContentManagement/Banners/types/BannerAdmin';
import StorefrontBannerCanvas from './StorefrontBannerCanvas';

type Props = {
  banners: StorefrontBanner[];
  fixedHeight?: number;
};

const ROTATE_INTERVAL = 5000;

const HeroBannerCarousel: FC<Props> = ({ banners, fixedHeight }) => {
  const theme = useTheme();
  const [activeIndex, setActiveIndex] = useState(0);

  const count = banners.length;

  const next = useCallback(() => {
    if (count <= 1) return;
    setActiveIndex((prev) => (prev + 1) % count);
  }, [count]);

  useEffect(() => {
    if (count <= 1) return;
    const timer = setInterval(next, ROTATE_INTERVAL);
    return () => clearInterval(timer);
  }, [next, count]);

  if (count === 0) return null;

  const banner = banners[activeIndex];

  return (
    <Box sx={{ position: 'relative' }}>
      <Box>
        <StorefrontBannerCanvas banner={banner}
          fixedHeight={fixedHeight} />
      </Box>
      {count > 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 1.5 }}>
          {banners.map((_, i) => (
            <Box
              key={i}
              onClick={() => setActiveIndex(i)}
              sx={{
                width: i === activeIndex ? 24 : 8,
                height: 8,
                borderRadius: '4px',
                backgroundColor: i === activeIndex
                  ? theme.palette.primary.main
                  : theme.palette.custom.gray[300],
                cursor: 'pointer',
                transition: 'all 0.3s ease',
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default HeroBannerCarousel;
